export const loadHomePage = () => import('./home/HomePage');

export const loadParticipationTaskPage = () =>
  import('./participation-task/ParticipationTaskPage');

/**
 * Start loading the Home and questionnaire page code, which the participation
 * pages need first. Failures are dropped; the router loads the code again on
 * navigation.
 */
export const preloadParticipationPages = (): void => {
  loadHomePage().catch(() => undefined);
  loadParticipationTaskPage().catch(() => undefined);
};
